import React, { useState } from 'react';

import { dateService } from '../../../services/date';
import { session } from '../../../services/session';

import DetailBanner from './detail-banner';
import MerchantStrategyTotals from './merchant-strategy-totals';
import OverviewTable from './overview-table';
import DatePicker from '../../base/date/date-picker';
import './merchant-performance-overview.scss';

const statType = 'merchant-performance-overview';

const defaultDateParams = {
  startDate: dateService.getStartOf(null, 'month'),
  endDate: dateService.getCurrentDateTime(),
};

function MerchantPerformanceOverview({ merchId, history, location, match }) {
  const [dateRange, setDateRange] = useState(defaultDateParams);
  const adminVisibility = session.isAdminView ? (
    <span className="admin-notice">Visible to Admins Only</span>
  ) : null;
  const detailBanner = session.isAdminView ? <DetailBanner /> : null;

  const setDates = (startDate, endDate) => {
    setDateRange({
      startDate: dateService.dateFromStr(startDate),
      endDate: dateService.dateFromStr(endDate),
    });
  };

  return (
    <div className="merchant-performance-overview">
      <div className="page-header">
        <h2>Your Campaign Performance</h2>
        {adminVisibility}
      </div>
      {detailBanner}
      <div className="totals-header">
        <p className="title">Overview</p>
        <DatePicker
          eventPrefix="Campaign Performance Date Picker"
          setDateRange={setDates}
          dateRange={dateRange}
          allowFutureDates={false}
          futureLimit={dateService.getCurrentDateTime()}
        />
      </div>
      <MerchantStrategyTotals merchId={merchId} statType={statType} dateRange={dateRange} />
      <OverviewTable
        merchId={merchId}
        statType={statType}
        history={history}
        location={location}
        match={match}
        dateRange={dateRange}
      />
    </div>
  );
}

export default MerchantPerformanceOverview;
